import styled, { css } from 'styled-components';
import trash from '../../../../../assets/icons/trash.svg';
import trashVa from '../../../../../assets/icons/trash_VA.svg';
import trashUb from '../../../../../assets/icons/trash_UB.svg';
import trashCm from '../../../../../assets/icons/trash_CM.svg';
import trashHover from '../../../../../assets/icons/trash_hover.svg';
import trashHoverVa from '../../../../../assets/icons/trash_hover_VA.svg';
import trashHoverUb from '../../../../../assets/icons/trash_hover_UB.svg';
import trashHoverCm from '../../../../../assets/icons/trash_hover_CM.svg';
import rotate from '../../../../../assets/icons/rotate.svg';
import rotateVa from '../../../../../assets/icons/rotate_VA.svg';
import rotateUb from '../../../../../assets/icons/rotate_UB.svg';
import rotateCm from '../../../../../assets/icons/rotate_CM.svg';
import rotateHover from '../../../../../assets/icons/rotate_hover.svg';
import rotateHoverVa from '../../../../../assets/icons/rotate_hover_VA.svg';
import rotateHoverUb from '../../../../../assets/icons/rotate_hover_UB.svg';
import rotateHoverCm from '../../../../../assets/icons/rotate_hover_CM.svg';
import star from '../../../../../assets/icons/star.svg';
import starVa from '../../../../../assets/icons/star_VA.svg';
import starUb from '../../../../../assets/icons/star_UB.svg';
import starCm from '../../../../../assets/icons/star_CM.svg';
import starHover from '../../../../../assets/icons/star_hover.svg';
import starHoverVa from '../../../../../assets/icons/star_hover_VA.svg';
import starHoverUb from '../../../../../assets/icons/star_hover_UB.svg';
import starHoverCm from '../../../../../assets/icons/star_hover_CM.svg';
import starIcon from '@panel/commons/assets/icons/star.svg';
import { select } from '@panel/commons/core/themev2';
import { isMobileDevice } from '@panel/commons/helpers/device';
import { getColor } from '@panel/commons/core/themev3';
import { site } from '@panel/commons/helpers';
import ChevronDownGray from '../../../../../assets/icons/ChevronDownGray.svg';

const isMobile = isMobileDevice();
const siteId = site.id;

const getIcon = (name, type) => {
  const sites = {
    CMBR: {
      trash: { icon: trashCm, hover: trashHoverCm },
      rotate: { icon: rotateCm, hover: rotateHoverCm },
      star: { icon: starCm, hover: starHoverCm }
    },
    VAMX: {
      trash: { icon: trashVa, hover: trashHoverVa },
      rotate: { icon: rotateVa, hover: rotateHoverVa },
      star: { icon: starVa, hover: starHoverVa }
    },
    UBPE: {
      trash: { icon: trashUb, hover: trashHoverUb },
      rotate: { icon: rotateUb, hover: rotateHoverUb },
      star: { icon: starUb, hover: starHoverUb }
    },
    default: {
      trash: { icon: trash, hover: trashHover },
      rotate: { icon: rotate, hover: rotateHover },
      star: { icon: star, hover: starHover }
    }
  };
  return sites[siteId]?.[name][type] || sites.default[name][type];
};

const SubtitleHelper = styled.p`
  color: ${select('neutralDarkGrayII')};
  font-family: Hind;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
`;

const SectionContainer = styled.div`
  display: flex;
`;

const CollapseContainer = styled.div`
  width: 100%;
  max-height: ${({ maxHeight }) => `calc(${maxHeight} + 0.5px)`};
  min-height: ${({ hasItems }) => {
    if (!hasItems) return '180px';
    return 'auto';
  }};
  margin-top: 16px;
  transition: max-height 0.3s ease;
  overflow: hidden;
  margin-bottom: ${({ hasToggleButton }) => (hasToggleButton ? '24px' : '0')};
`;

const FilesContainer = styled.div`
  width: 100%;
  display: grid;
  gap: 16px;
  grid-template-columns: ${({ hasItems, device }) => {
    if (!hasItems) return '1fr';
    if (device === 'mobile') return 'repeat(2, 1fr)';
    return 'repeat(3, 1fr)';
  }};
  justify-content: center;
`;

const CollapseWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const DropzoneContainer = styled.div`
  width: 100%;
  aspect-ratio: ${({ hasItems }) => (hasItems ? '1 / 1' : 'auto')};
  height: ${({ hasItems }) => {
    if (!hasItems) return '180px';
    return 'auto';
  }};
  border: dashed 1px
    ${({ disabled, hasLowLimit }) => {
      if (hasLowLimit) return select('redNoTRecommended');
      if (disabled) return select('neutralDarkGrayII');
      return getColor('primary');
    }};
  border-radius: 16px;
  padding: ${({ hasItems }) => (hasItems ? '32px' : '0px')};
  background-color: ${select('white')};
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: ${({ disabled }) => (!disabled ? 'pointer' : 'auto')};
    border-style: ${({ disabled }) => (!disabled ? 'solid' : 'dashed')};
  }
  span {
    max-width: ${({ hasItems }) => (hasItems ? '99px' : 'auto')};
    margin-top: 10px;
    font-family: 'Hind';
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    word-wrap: break-word;
    white-space: pre-wrap;
    text-align: center;
    color: ${({ disabled, hasLowLimit }) => {
      if (disabled) return select('midDarkGrayAux');
      if (hasLowLimit) return select('redNoTRecommended');
      return select('black');
    }};
  }
  transition: border 0.25s ease-in-out;
`;

const ImageBoxContainer = styled.div`
  width: 100%;
  aspect-ratio: 1/1;
  border: 1px solid ${select('midNeutralGray')};
  border-radius: 16px;
  background-color: ${select('white')};
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  opacity: ${({ opacity }) => opacity};
  /* Prevenimos el menú contextual nativo en iOS y Android */
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  user-select: none;
`;

const MainMarker = styled.div`
  width: 100%;
  height: 32px;
  color: white;
  font-size: 12px;
  font-weight: 400;
  padding: 5px 10px;
  background-color: ${getColor('primary')};
  border-radius: 8px 8px 0px 0px;
  text-align: center;
  position: absolute;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  div {
    height: 14px;
    width: 14px;
    margin-bottom: 4px;
    background-image: url(${starIcon});
    background-size: cover;
    margin-right: 8px;
  }
`;

const ImageBorderWrapper = styled.div`
  border-radius: 8px 8px 0px 0px;
  overflow: hidden;
  width: 100%;
  height: 100%;
  &:hover {
    cursor: move;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: height 1s ease;
  transform: ${props => (props.rotationAngle ? `rotate(${props.rotationAngle}deg)` : '')};
  /* Prevenimos el drag nativo de imágenes en iOS Safari, que hace que la imagen se pueda arrastrar 
  para abrirla con su url en una nueva pestaña */
  -webkit-user-drag: none;
  -webkit-touch-callout: none;
`;

const Controls = styled.div`
  position: absolute;
  width: 100%;
  text-align: right;
  z-index: 3;
  bottom: -1px;
  visibility: ${({ device }) => (device === 'desktop' ? 'hidden' : 'visible')};
  transition: visibility 0s ease-out;
  padding-right: 8px;
  ${ImageBoxContainer}:hover & {
    visibility: visible;
  }
  box-sizing: border-box;
  overflow: hidden;
  span:last-child {
    margin: 0;
  }
`;

const mobileEventConfig = hoverImg => {
  return isMobile
    ? css`
        &:active {
          background-image: url(${hoverImg});
        }
      `
    : css`
        &:hover {
          background-image: url(${hoverImg});
        }
      `;
};

const Rotator = styled.span`
  width: 32px;
  height: 32px;
  cursor: pointer;
  display: inline-block;
  background-image: url(${getIcon('rotate', 'icon')});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 4px;
  ${mobileEventConfig(getIcon('rotate', 'hover'))}
`;

const Deletor = styled(Rotator)`
  background-image: url(${getIcon('trash', 'icon')});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  ${mobileEventConfig(getIcon('trash', 'hover'))}
`;

const MainSelector = styled(Rotator)`
  background-image: url(${getIcon('star', 'icon')});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  ${mobileEventConfig(getIcon('star', 'hover'))}
`;

const LoadingView = styled.div`
  width: ${props => props.width};
  height: ${props => props.height};
  .loader {
    position: relative;
    margin: 0 auto;
    width: ${props => props.width};
    z-index: 4;
    &:before {
      content: '';
      display: block;
      padding-top: 100%;
    }
  }

  .circular {
    animation: rotate 3s linear infinite;
    height: 64px;
    transform-origin: center center;
    width: 50%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }

  .path {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    animation: dash 1.5s ease-in-out infinite;
    stroke-linecap: round;
    stroke: ${getColor('primary')};
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -35px;
    }
    100% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -124px;
    }
  }
`;

const SnackContainer = styled.div`
  position: relative;
  margin: 0 auto;
  width: 100%;
  display: flex;
  justify-content: center;
  height: 50px;
  padding: 0;
`;

const ImgOverlay = styled.div`
  z-index: 3;
  background: ${props => props.hasError && select('negative')};
  width: 100%;
  height: ${props => (props.hasError ? '100%' : '82%')};
  position: absolute;
  opacity: 0.7;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const ErrorMessage = styled.div`
  white-space: normal;
  padding: 30px;
  color: ${select('white')};
  font-family: Hind;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
`;

const CardShowMore = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 180px;
  height: 216px;
  background: linear-gradient(145.22deg, ${select('white')} 0%, ${select('lightGray')} 100%);
  border-radius: 8px;
  border: 0.5px solid ${select('midDarkGray')};
  > div:nth-child(1) {
    margin-top: 52px;
    font-size: 32px;
    color: ${getColor('primary')};
    font-weight: bold;
  }
`;

const ShowMore = styled.div`
  cursor: pointer;
  font-size: 16px;
  color: ${getColor('primary')};
  font-weight: 600;
`;

const ToggleButton = styled.button`
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 9px;
  align-self: ${({ device }) => (device === 'mobile' ? 'center' : 'flex-end')};
  margin-right: ${({ device }) => (device === 'mobile' ? '0' : '13px')};
  margin-top: ${({ device }) => (device === 'mobile' ? '12px' : '8px')};
  cursor: pointer;
  text-decoration: none;
  :hover {
    text-decoration: ${({ device }) => (device === 'mobile' ? 'none' : 'underline')};
  }
`;

const Chevron = styled.span`
  width: 10px;
  height: 7px;
  margin-bottom: 2px;
  background-image: url(${ChevronDownGray});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  transform: ${({ active }) => `rotateX(${active ? '0deg' : '180deg'})`};
  transition: all 0.3s ease;
  cursor: pointer;
`;

export {
  SubtitleHelper,
  SectionContainer,
  FilesContainer,
  DropzoneContainer,
  ImageBoxContainer,
  MainMarker,
  ImageBorderWrapper,
  Image,
  Controls,
  Rotator,
  Deletor,
  LoadingView,
  SnackContainer,
  CollapseContainer,
  CollapseWrapper,
  MainSelector,
  ImgOverlay,
  ErrorMessage,
  CardShowMore,
  ShowMore,
  ToggleButton,
  Chevron
};
